import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Link as RouterLink } from 'react-router-dom';
import {
    Container, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
    TextField, Button, LinearProgress, FormControl
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { saveAsTemplate, openSaveAsTemplateDialog, updateSaveAsTemplateFormName } from '../../actions/configuration';
import equal from 'fast-deep-equal';
import { useTranslation } from 'react-i18next';
import useUser from '../../user/useUser';

const SaveAsTemplateDialog = () => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const { token, unsetUser } = useUser();
    const loading = useSelector(state => state.global.loading);
    const alarmSystem = useSelector(state => state.configuration.alarmSystem);
    const configuration = useSelector(state => state.configuration.configuration);
    const saveAsTemplateDialog = useSelector(state => state.configuration.saveAsTemplateDialog);
    const generalErrorText = useSelector(state => state.configuration.generalErrorText);
    const dispatch = useDispatch();
    const language = i18n.languages[0];

    if (!alarmSystem || !configuration)
        return null;

    return (
        <Dialog
            disableBackdropClick={loading}
            open={saveAsTemplateDialog.isOpen}
            onClose={() => dispatch(openSaveAsTemplateDialog(false))}>
            <DialogTitle>{t("SaveAsTemplate")}</DialogTitle>
            <DialogContent>

                {loading ? <LinearProgress style={{ height: 3 }} /> : <div style={{ height: 3 }} />}

                {generalErrorText ? <Alert style={{ marginTop: 10 }} severity="error">{generalErrorText}</Alert> : null}

                <div style={{ maxWidth: 300, marginTop: 20, marginBottom: 20 }}>

                    <FormControl fullWidth style={{ marginTop: 10 }}>
                        <TextField
                            disabled={loading}
                            autoFocus
                            fullWidth
                            type="text"
                            value={saveAsTemplateDialog.formData.name}
                            label={t("Name")}
                            error={!!saveAsTemplateDialog.formData.nameErrorText}
                            helperText={saveAsTemplateDialog.formData.nameErrorText}
                            onChange={event => dispatch(updateSaveAsTemplateFormName(event.target.value, t))}
                        />
                    </FormControl>
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={loading} onClick={() => dispatch(openSaveAsTemplateDialog(false))} color="primary">
                    {t("Cancel")}
                </Button>
                <Button disabled={loading || !saveAsTemplateDialog.formData.isValid}
                    onClick={() => dispatch(saveAsTemplate(alarmSystem.id, saveAsTemplateDialog.formData.name, configuration, history, token, unsetUser, t, language))}
                    color="primary">
                    {t("SaveAsTemplate")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default SaveAsTemplateDialog;